import { getEnvironmentVariableByName } from "@ob/core";
const baseUrl = getEnvironmentVariableByName("API_BASE_PATH");
export const LINK_PRIVACY_POLICY = `https://quick2cash.it/informativa-privacy/`;
export const LINK_COOKIE_POLICY = `https://quick2cash.it/cookie-policy/`;

const getProductType = () => {
  const location = window.location.pathname;
  if (location.includes("plus")) return "plus";
  return "base";
};

const LINK_INFORMATION_SHEET_MAP = {
  base: `${baseUrl}/SSRDocumentDisplayer?dtdPG=FI_QUICK2CASH&dtdPE=1`,
  plus: `${baseUrl}/SSRDocumentDisplayer?dtdPG=FI_QUICK2CASH_PLUS&dtdPE=1`,
};

export const LINK_INFORMATION_SHEET =
  LINK_INFORMATION_SHEET_MAP[getProductType()];
